define((require) => {
    "use strict";

    var Marionette              = require("marionette"),
        LoggedInUserState       = require("shared/ui/user/LoggedInUserState"),
        BreakpointSettingsView  = require("ui/settings/breakpoint/BreakpointSettingsView");

    return Marionette.Controller.extend({

        showBreakpointSettingsView: function() {
            var companySettings = LoggedInUserState.get("companySettings"),
                breakpoints = companySettings.get("breakpoints");

            this.options.region.show(new BreakpointSettingsView({
                collection: breakpoints
            }));

            this.listenTo(breakpoints, "add remove change", () => {
                companySettings.saveLater();
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/breakpoint/BreakpointController.js